import { css } from 'lit';
/* eslint-disable max-lines */

import { QuantityType } from '@/config/ConfigQuantityTypes';
import { Color } from '@typings/shared-types';
import { FormSectionsRecord } from './ConfigREM';

// TODO: Have the API provide as many event type related configurations as possible to avoid possible desyncs between the data and the frontend config
// List of all event types returned by the events/fields endpoint
export const EventTypes = {
	STOPPED_TRAFFIC: 'STOPPED TRAFFIC',
  STOP_AND_GO_TRAFFIC: 'STOP AND GO TRAFFIC',
  HEAVY_TRAFFIC: 'HEAVY TRAFFIC',
  MEDICAL_EMERGENCY: 'MEDICAL EMERGENCY',
  STALLED_VEHICLE: 'STALLED VEHICLE',
  DISABLED_VEHICLE: 'DISABLED VEHICLE',
  VEHICLE_ON_FIRE: 'VEHICLE ON FIRE',
  JACKKNIFED_SEMI_TRAILER: 'JACKKNIFED SEMI TRAILER',
  FUEL_SPILL: 'FUEL SPILL',
  HAZARDOUS_MATERIALS_SPILL: 'HAZARDOUS MATERIALS SPILL',
  SPILLED_LOAD: 'SPILLED LOAD',
  OVERTURNED_SEMI_TRAILER: 'OVERTURNED SEMI TRAILER',
  OVERTURNED_BUS: 'OVERTURNED BUS',
  DERAILED_TRAIN: 'DERAILED TRAIN',
  CRASH: 'CRASH',
  CRASH_INVOLVING_A_BICYCLE: 'CRASH INVOLVING A BICYCLE',
  CRASH_INVOLVING_A_BUS: 'CRASH INVOLVING A BUS',
  CRASH_INVOLVING_A_MOTORCYCLE: 'CRASH INVOLVING A MOTORCYCLE',
  CRASH_INVOLVING_A_PEDESTRIAN: 'CRASH INVOLVING A PEDESTRIAN',
  CRASH_INVOLVING_A_TRAIN: 'CRASH INVOLVING A TRAIN',
  CRASH_INVOLVING_HAZARDOUS_MATERIALS: 'CRASH INVOLVING HAZARDOUS MATERIALS',
  EARLIER_CRASH: 'EARLIER CRASH',
  CRASH_INVOLVING_A_SEMI_TRAILER: 'CRASH INVOLVING A SEMI TRAILER',
  SECONDARY_CRASH: 'SECONDARY CRASH',
  CLOSED_TO_TRAFFIC: 'CLOSED TO TRAFFIC',
  CLOSED: 'CLOSED',
  CLOSED_INTERMITTENTLY: 'CLOSED INTERMITTENTLY',
  OPEN_TO_TRAFFIC: 'OPEN TO TRAFFIC',
  REST_AREA_CLOSED: 'REST AREA CLOSED',
  BRIDGE_CLOSED: 'BRIDGE CLOSED',
  LOCAL_ROAD_CLOSURES_IN_AREA: 'LOCAL ROAD CLOSURES IN AREA',
  DETOUR_IN_OPERATION: 'DETOUR IN OPERATION',
  ROAD_CLOSURE: 'ROAD CLOSURE',
  INTERMITTENT_LANE_CLOSURE: 'INTERMITTENT LANE CLOSURE',
  ALTERNATING_LANE_CLOSURES: 'ALTERNATING LANE CLOSURES',
  LONG_TERM_ROAD_CONSTRUCTION: 'LONG TERM ROAD CONSTRUCTION',
  CONSTRUCTION_WORK: 'CONSTRUCTION WORK',
  PAVING_OPERATIONS: 'PAVING OPERATIONS',
  WORK_IN_THE_MEDIAN: 'WORK IN THE MEDIAN',
  NARROW_LANES: 'NARROW LANES',
  CONSTRUCTION_TRAFFIC_MERGING: 'CONSTRUCTION TRAFFIC MERGING',
  SINGLE_LINE_TRAFFIC_ALTERNATING_DIRECTIONS: 'SINGLE LINE TRAFFIC: ALTERNATING DIRECTIONS',
  ROAD_MAINTENANCE_OPERATIONS: 'ROAD MAINTENANCE OPERATIONS',
  ROAD_MARKING_OPERATIONS: 'ROAD MARKING OPERATIONS',
  BRIDGE_MAINTENANCE_OPERATIONS: 'BRIDGE MAINTENANCE OPERATIONS',
  BRIDGE_CONSTRUCTION: 'BRIDGE CONSTRUCTION',
  BRIDGE_DEMOLITION_WORK: 'BRIDGE DEMOLITION WORK',
  WATER_MAIN_WORK: 'WATER MAIN WORK',
  GAS_MAIN_WORK: 'GAS MAIN WORK',
  WORK_ON_UNDERGROUND_CABLES: 'WORK ON UNDERGROUND CABLES',
  WORK_ON_UNDERGROUND_SERVICES: 'WORK ON UNDERGROUND SERVICES',
  TEMPORARY_LANE_MARKINGS: 'TEMPORARY LANE MARKINGS',
  TEMPORARY_TRAFFIC_LIGHTS: 'TEMPORARY TRAFFIC LIGHTS',
  EMERGENCY_MAINTENANCE: 'EMERGENCY MAINTENANCE',
  ROADSIDE_CLEANUP_CREW: 'ROADSIDE CLEANUP CREW',
  BRIDGE_INSPECTION_WORK: 'BRIDGE INSPECTION WORK',
  NIGHT_TIME_CONSTRUCTION_WORK: 'NIGHT TIME CONSTRUCTION WORK',
  WORK_ON_THE_SHOULDER: 'WORK ON THE SHOULDER',
  EMERGENCY_REPAIRS: 'EMERGENCY REPAIRS',
  STREET_CLEANING: 'STREET CLEANING',
  UTILITY_WORK: 'UTILITY WORK',
  ROADWORK: 'ROADWORK',
  AUTOMATED_ENFORCEMENT_AREA: 'AUTOMATED ENFORCEMENT AREA',
  OBSTRUCTION_ON_ROADWAY: 'OBSTRUCTION ON ROADWAY',
  DEBRIS_ON_ROADWAY: 'DEBRIS ON ROADWAY',
  STORM_DAMAGE: 'STORM DAMAGE',
  HERD_OF_ANIMALS_ON_ROADWAY: 'HERD OF ANIMALS ON ROADWAY',
  FALLEN_TREES: 'FALLEN TREES',
  DOWNED_POWER_LINES: 'DOWNED POWER LINES',
  DOWNED_CABLES: 'DOWNED CABLES',
  ROAD_SURFACE_COLLAPSE: 'ROAD SURFACE COLLAPSE',
  PAVEMENT_BUCKLED: 'PAVEMENT BUCKLED',
  POTHOLE: 'POTHOLE',
  FLOODING: 'FLOODING',
  BROKEN_WATER_MAIN: 'BROKEN WATER MAIN',
  COLLAPSED_SEWER: 'COLLAPSED SEWER',
  GAS_LEAK: 'GAS LEAK',
  POLICE_DIRECTING_TRAFFIC: 'POLICE DIRECTING TRAFFIC',
  ROUGH_ROAD: 'ROUGH ROAD',
  VEHICLE_FIRE: 'VEHICLE FIRE',
  FIRE: 'FIRE',
  BUILDING_FIRE: 'BUILDING FIRE',
  LOCAL_EVENT: 'LOCAL EVENT',
  OVERSIZE_LOAD: 'OVERSIZE LOAD',
  TRAFFIC_HAZARD: 'TRAFFIC HAZARD',
  DELAYS: 'DELAYS',
  SHORT_DELAYS: 'SHORT DELAYS',
  LONG_DELAYS: 'LONG DELAYS',
  VERY_LONG_DELAYS: 'VERY LONG DELAYS',
  EMERGENCY_VEHICLES: 'EMERGENCY VEHICLES',
  WIDE_LOAD: 'WIDE LOAD',
  OVERHEIGHT_LOAD: 'OVERHEIGHT LOAD',
  OVERWEIGHT_LOAD: 'OVERWEIGHT LOAD',
  SLOW_MOVING_MAINTENANCE_VEHICLE: 'SLOW MOVING MAINTENANCE VEHICLE',
  CONVOY: 'CONVOY',
  SNOWPLOWS: 'SNOWPLOWS',
  MOBILE_MAINTENANCE_OPERATIONS: 'MOBILE MAINTENANCE OPERATIONS',
  LANE_CONTROL_SIGNS_NOT_WORKING: 'LANE CONTROL SIGNS NOT WORKING',
  LANE_CONTROL_SIGNS_WORKING_INCORRECTLY: 'LANE CONTROL SIGNS WORKING INCORRECTLY',
  VARIABLE_MESSAGE_SIGNS_NOT_WORKING: 'VARIABLE MESSAGE SIGNS NOT WORKING',
  VARIABLE_MESSAGE_SIGNS_WORKING_INCORRECTLY: 'VARIABLE MESSAGE SIGNS WORKING INCORRECTLY',
  TRAFFIC_LIGHTS_NOT_WORKING: 'TRAFFIC LIGHTS NOT WORKING',
  TRAFFIC_LIGHTS_WORKING_INCORRECTLY: 'TRAFFIC LIGHTS WORKING INCORRECTLY',
  RAMP_CONTROL_SIGNALS_NOT_WORKING: 'RAMP CONTROL SIGNALS NOT WORKING',
  RAMP_CONTROL_SIGNALS_WORKING_INCORRECTLY: 'RAMP CONTROL SIGNALS WORKING INCORRECTLY',
  TEMPORARY_TRAFFIC_LIGHTS_NOT_WORKING: 'TEMPORARY TRAFFIC LIGHTS NOT WORKING',
  TEMPORARY_TRAFFIC_LIGHTS_WORKING_INCORRECTLY: 'TEMPORARY TRAFFIC LIGHTS WORKING INCORRECTLY',
  TRAFFIC_SIGNAL_MAINTENANCE_WORK: 'TRAFFIC SIGNAL MAINTENANCE WORK',
  RESTRICTIONS: 'RESTRICTIONS',
  RAMP_RESTRICTIONS: 'RAMP RESTRICTIONS',
  TRUCK_RESTRICTION: 'TRUCK RESTRICTION',
  SPEED_RESTRICTION: 'SPEED RESTRICTION',
  LOCAL_ACCESS_ONLY: 'LOCAL ACCESS ONLY',
  NO_TRAILERS: 'NO TRAILERS',
  NO_THROUGH_TRAFFIC: 'NO THROUGH TRAFFIC',
  WIDTH_LIMIT: 'WIDTH LIMIT',
  HEIGHT_LIMIT: 'HEIGHT LIMIT',
  LENGTH_LIMIT: 'LENGTH LIMIT',
  AXLE_LOAD_LIMIT: 'AXLE LOAD LIMIT',
  GROSS_WEIGHT_LIMIT: 'GROSS WEIGHT LIMIT',
  NO_OVERLOADS: 'NO OVERLOADS',
  PERMITTED_OVERSIZE_LOADS_PROHIBITED: 'PERMITTED OVERSIZE LOADS PROHIBITED',
  NO_COMMERCIAL_TRAILER_TRAFFIC: 'NO COMMERCIAL TRAILER TRAFFIC',
  ROUNDABOUT: 'ROUNDABOUT',
  GRASS_FIRE: 'GRASS FIRE',
  SLOW_TRAFFIC: 'SLOW TRAFFIC',
  LONG_QUEUES: 'LONG QUEUES',
  TRAFFIC_CONGESTION: 'TRAFFIC CONGESTION',
  CLOSED_AHEAD: 'CLOSED AHEAD',
  CLOSED_FOR_REPAIRS: 'CLOSED FOR REPAIRS',
  BLOCKED: 'BLOCKED',
  REDUCED_TO_ONE_LANE: 'REDUCED TO ONE LANE',
  REDUCED_TO_TWO_LANES: 'REDUCED TO TWO LANES',
  REDUCED_TO_THREE_LANES: 'REDUCED TO THREE LANES',
  CONSIDER_ALTERNATE_ROUTE: 'CONSIDER ALTERNATE ROUTE',
  CLEARED: 'CLEARED',
  RIGHT_LANE_CLOSED: 'RIGHT LANE CLOSED',
  LEFT_LANE_CLOSED: 'LEFT LANE CLOSED',
  CENTER_LANE_CLOSED: 'CENTER LANE CLOSED',
  RIGHT_SHOULDER_CLOSED: 'RIGHT SHOULDER CLOSED',
  LEFT_SHOULDER_CLOSED: 'LEFT SHOULDER CLOSED',
  EXIT_RAMP_CLOSED: 'EXIT RAMP CLOSED',
  ENTRANCE_RAMP_CLOSED: 'ENTRANCE RAMP CLOSED',
  THROUGH_LANES_CLOSED: 'THROUGH LANES CLOSED',
  SHOULDER_CLOSED: 'SHOULDER CLOSED',
  PILOT_CAR_IN_OPERATION: 'PILOT CAR IN OPERATION',
  RIGHT_LANE_BLOCKED: 'RIGHT LANE BLOCKED',
  TWO_RIGHT_LANES_BLOCKED: 'TWO RIGHT LANES BLOCKED',
  THREE_RIGHT_LANES_BLOCKED: 'THREE RIGHT LANES BLOCKED',
  LEFT_LANE_BLOCKED: 'LEFT LANE BLOCKED',
  TWO_LEFT_LANES_BLOCKED: 'TWO LEFT LANES BLOCKED',
  LEFT_LANE_OF_EXIT_RAMP_CLOSED: 'LEFT LANE OF EXIT RAMP CLOSED',
  RIGHT_LANE_OF_EXIT_RAMP_CLOSED: 'RIGHT LANE OF EXIT RAMP CLOSED',
  RAMP_BLOCKED: 'RAMP BLOCKED',
  CLOSED_TO_ALL_TRAFFIC_EXCEPT_EMERGENCY_VEHICLES: 'CLOSED TO ALL TRAFFIC EXCEPT EMERGENCY VEHICLES',
  ALL_LANES_BLOCKED: 'ALL LANES BLOCKED',
  SIDEWALK_CLOSED: 'SIDEWALK CLOSED',
  LEFT_TURN_BAY_CLOSED: 'LEFT TURN BAY CLOSED',
  RIGHT_TURN_BAY_CLOSED: 'RIGHT TURN BAY CLOSED',
  LANE_CLOSED: 'LANE CLOSED',
  ROAD_CONSTRUCTION: 'ROAD CONSTRUCTION',
  MAJOR_ROAD_CONSTRUCTION: 'MAJOR ROAD CONSTRUCTION',
  ROAD_RECONSTRUCTION: 'ROAD RECONSTRUCTION',
  OPPOSING_TRAFFIC: 'OPPOSING TRAFFIC',
  NEW_ROAD_CONSTRUCTION_LAYOUT: 'NEW ROAD CONSTRUCTION LAYOUT',
  NEW_ROAD_LAYOUT: 'NEW ROAD LAYOUT',
  BRUSH_CONTROL: 'BRUSH CONTROL',
  PLANNED_ROADWORK: 'PLANNED ROADWORK',
  FESTIVAL: 'FESTIVAL',
  PARADE: 'PARADE',
  RAMP_PARTIALLY_BLOCKED: 'RAMP PARTIALLY BLOCKED',
  TEMPORARY_FOUR_WAY_STOP_CONDITION: 'TEMPORARY FOUR WAY STOP CONDITION',
  BICYCLE_RACE: 'BICYCLE RACE',
  FAIR: 'FAIR',
  WE_APPRECIATE_YOUR_PATIENCE: 'WE APPRECIATE YOUR PATIENCE',
  EXTRA_POLICE_PATROLS_IN_OPERATION: 'EXTRA POLICE PATROLS IN OPERATION',
  REPAIRS_IN_PROGRESS: 'REPAIRS IN PROGRESS',
  LOOK_OUT_FOR_FLAGGER: 'LOOK OUT FOR FLAGGER',
  FINES_ARE_DOUBLED_IN_THE_WORK_ZONE: 'FINES ARE DOUBLED IN THE WORK ZONE',
  CHANGING_TRAFFIC_PATTERNS: 'CHANGING TRAFFIC PATTERNS',
  TRUCKS_ENTERING_ROADWAY: 'TRUCKS ENTERING ROADWAY',
  USE_RIGHT_LANE: 'USE RIGHT LANE',
  USE_LEFT_LANE: 'USE LEFT LANE',
  THROUGH_TRAFFIC_KEEP_LEFT: 'THROUGH TRAFFIC KEEP LEFT',
  THROUGH_TRAFFIC_KEEP_RIGHT: 'THROUGH TRAFFIC KEEP RIGHT',
  NORTHBOUND_TRAFFIC: 'NORTHBOUND TRAFFIC',
  EASTBOUND_TRAFFIC: 'EASTBOUND TRAFFIC',
  SOUTHBOUND_TRAFFIC: 'SOUTHBOUND TRAFFIC',
  WESTBOUND_TRAFFIC: 'WESTBOUND TRAFFIC',
  FOLLOW_DETOUR_SIGNS: 'FOLLOW DETOUR SIGNS',
  FOLLOW_LOCAL_DETOUR: 'FOLLOW LOCAL DETOUR',
  TRUCKS_ARE_RECOMMENDED_TO_AVOID_THE_AREA: 'TRUCKS ARE RECOMMENDED TO AVOID THE AREA',
} as const;

enum RespondingUnitType {
	FIRE_DEPARTMENT = 'FIRE DEPARTMENT',
	EMS = 'EMS, EMERGENCY, MEDICAL SERVICES',
	CORONER = 'CORONER, MEDICAL, CORONER',
	CONSTRUCTION = 'CONSTRUCTION',
	ISP = 'ISP, STATE POLICE',
	HEALTH_DEPT = 'HEALTH DEPT',
	HAZMAT_RESPONSE = 'HAZMAT RESPONSE',
	BRIDGE = 'BRIDGE, INDOT, BRIDGE INSPECTOR',
	HOOSIER_HELPER = 'HOOSIER HELPER',
	VINCENNES_DISTRICT = 'VINCENNES DISTRICT',
	GREENFIELD_DISTRICT = 'GREENFIELD DISTRICT',
	CRAWFORDSVILLE_DISTRICT = 'CRAWFORDSVILLE DISTRICT',
	TMC_DISPATCHER = 'TMC DISPATCHER',
	SEYMOUR_DISTRICT = 'SEYMOUR DISTRICT',
	MEDEVAC = 'MEDEVAC/LIFELINE AIR AMBULANCE',
	MAINTENANCE = 'MAINTENANCE',
	SPILL_RECOVERY = 'SPILL, RECOVERY',
	SIGNAL_TECH = 'SIGNAL, SIGNAL, TECH',
	LOCAL_CITY_COUNTY_POLICE = 'LOCAL CITY/COUNTY POLICE',
	PENDING_UNIT = 'PENDING UNIT',
	FT_WAYNE_DISTRICT = 'FT WAYNE DISTRICT',
	LAPORTE_DISTRICT = 'LAPORTE DISTRICT',
	ATIS_ADMINISTRATOR = 'ATIS ADMINISTRATOR/CUSTOM MESSAGE',
	WRECKER = 'WRECKER',
}

enum RespondingUnitDispositionType {
	AMA = 'AMA - AUTOMATED MESSAGE ACTIVATION',
	AVT = 'AVT - ABANDONED VEHICLE TAGGED',
	CMO = 'CMO - CALLED TO MAKE OWN ARRANGEMENTS',
	CMS = 'CMS - CUSTOM MESSAGE SCHEDULED (NOT AUTOMATED)',
	DCC = 'DCC - DUPLICATED CARD CANCELLED',
	DDO = 'DDO - DISREGARDED, MOTORIST DROVE OFF',
	DFV = 'DFV - DISPATCHED FOR FIELD VERIFICATION',
	DIO = 'DIO - DISPATCHED FOR INFORMATION ONLY',
	DNN = 'DNN - DISREGARD, NOT NEEDED',
	DNR = 'DNR - DID NOT RESPOND',
	DOS = 'DOS - MOTORIST DROVE OFF WHILE TECH ON-SITE',
	EEI = 'EEI - ERRANT ENTRY IGNORE',
	EFR = 'EFR - ESCORTED FROM ROADWAY',
	EMP = 'EMP - EMERGENCY PATCHING',
	FAA = 'FAA - FIRST AID ADMINISTERED',
	FMD = 'FMD - FUEL MOTORIST VEHICLE (DIESEL)',
	FMG = 'FMG - FUEL MOTORIST VEHICLE (GAS)',
	FSP = 'FSP - FIRE SUPPRESSION',
	HAZ = 'HAZ - HAZARDOUS RESPONSE OR CONTAINMENT / OIL DRY',
	INF = 'INF - INFORMATION / DIRECTIONS GIVEN',
	JMP = 'JMP - JUMP STARTED VEHICLE',
	MCP = 'MCP - MOTORIST ON CELL PHONE',
	MVR = 'MVR - MINOR VEHICLE REPAIR',
	NPS = 'NPS - NOTIFICATION PAGE SENT',
	NRE = 'NRE - NO REPORT (ONLY OBSERVED) EVENT (IN PROGRESS)',
	OTR = 'OTR - OTHER DISPOSITON',
	RAS = 'RAS - REFUSED ASSISTANCE',
	RIS = 'RIS - REMOVED ILLEGAL SIGN',
	RRW = 'RRW - RELOCATED TO / FROM ROADWAY',
	RTA = 'RTA - REFERRED TO ANOTHER AGENCY',
	RTD = 'RTD - REFERRED TO TECH DEPLOYMENT DIVISION',
	RTK = 'RTK - REPORT TAKEN',
	RXS = 'RXS - REQUESTED EXTERNAL SERVICES',
	SLD = 'SLD - SECURE LOAD',
	SMD = 'SMD - SLEEPING MOTORIST DROVE OFF',
	SPD = 'SPD - SPECIAL DETAIL',
	TCH = 'TCH - TIRE CHANGE',
	TFC = 'TFC - TRAFFIC CONTROL',
	TOC = 'TOC - TOWED FROM SCENE, OWNER CALLED',
	TPC = 'TPC - TOWED FROM SCENE, POLICE CALLED',
	TRN = 'TRN - TRAINING EVENT (PROVIDING OR RECEIVING)',
	UTL = 'UTL - UNABLE TO LOCATE',
	WCK = 'WCK - WELFARE CHECK',
	WPV = 'WPV - WATER / COOLANT PROVIDED IN VEHICLE',
}

export type EventType = typeof EventTypes[keyof typeof EventTypes];

interface EventTypeConfigOptions {
	// if true, events with this headline phrase will display on 511 by default
	importTo511: boolean;
	// phrase will display in this color in the descriptors list
	color?: Color | null;
	// user will be prompted to enter the specified restriction if the phrase is selected
	restriction?: QuantityType | null;
	// specify if dms, vehicles, and responding units sections should display by default
	defaultFormSections?: Partial<FormSectionsRecord<boolean>>;
	// suggested responding unit types and their corresponding suggested dispositions
	// if unspecified, all types and dispositions will be suggested
	// so far only used by INDOT
	respondingUnitSuggestions?: Record<string, string[]>;
	// if true, user will be prompted to enter an end date before saving the event
	shouldHaveEndDate?: boolean;
	// if true, this event type will be available in the work zone request tool
	isWorkZonePhrase?: boolean;
	// if true, this event type CANNOT be entered as a cause
	cannotBeCause?: boolean;
	// if true, this event type can only be a headline phrase for work zone requests
	isWorkZoneHeadlinePhrase?: boolean;
	// if true, this event type can only be a secondary phrase for work zone requests
	// if both isWorkZoneHeadlinePhrase and isWorkZoneSecondaryPhrase are left undefined, the event type can be used as either a headline or a secondary phrase
	isWorkZoneSecondaryPhrase?: boolean;
	// if true, events of this type will be set to priority 1 when all lanes in a direction are closed
	unplannedEvent?: boolean;
	// if true, user will be reminded to add the FHWA email group if the phrase is selected
	triggersFHWAReminder?: boolean;
}

// example empty config entry with minimum info:
// [EventTypes.NEW_EVENT_TYPE]: {
// 		importTo511: false,
// }

// example config entry with all info specified
// [EventTypes.NEW_EVENT_TYPE]: {
// 		importTo511: false,
// 		color: NON_HEADLINE_PHRASE_COLOR,
// 		restriction: null,
// 		defaultFormSections: {
// 			DMS: false,
// 			VEHICLES: false,
// 			RESPONDING_UNITS: true,
// 		},
// 		respondingUnitSuggestions: {
// 			[RespondingUnitType.HOOSIER_HELPER]: [
// 				RespondingUnitDispositionType.DFV,
// 				RespondingUnitDispositionType.DNN,
// 				RespondingUnitDispositionType.TFC,
// 			],
// 		},
// 		shouldHaveEndDate: true,
// 		isWorkZonePhrase: true,
// 		cannotBeCause: true,
// 		cannotBeHeadline: false,
// 	},

const NON_HEADLINE_PHRASE_COLOR: Color = '#1267e4';

export const EventTypeConfig: Partial<Record<EventType, EventTypeConfigOptions>> = {
	[EventTypes.STOPPED_TRAFFIC]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.STOP_AND_GO_TRAFFIC]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.HEAVY_TRAFFIC]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.MEDICAL_EMERGENCY]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.STALLED_VEHICLE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.DISABLED_VEHICLE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.VEHICLE_ON_FIRE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.JACKKNIFED_SEMI_TRAILER]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.FUEL_SPILL]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.HAZARDOUS_MATERIALS_SPILL]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.SPILLED_LOAD]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.OVERTURNED_SEMI_TRAILER]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.OVERTURNED_BUS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.DERAILED_TRAIN]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CRASH]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CRASH_INVOLVING_A_BICYCLE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CRASH_INVOLVING_A_BUS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CRASH_INVOLVING_A_MOTORCYCLE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CRASH_INVOLVING_A_PEDESTRIAN]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CRASH_INVOLVING_A_TRAIN]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CRASH_INVOLVING_HAZARDOUS_MATERIALS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.EARLIER_CRASH]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CRASH_INVOLVING_A_SEMI_TRAILER]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.SECONDARY_CRASH]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CLOSED_TO_TRAFFIC]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CLOSED_INTERMITTENTLY]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.OPEN_TO_TRAFFIC]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.REST_AREA_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.BRIDGE_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LOCAL_ROAD_CLOSURES_IN_AREA]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.DETOUR_IN_OPERATION]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.ROAD_CLOSURE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.INTERMITTENT_LANE_CLOSURE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.ALTERNATING_LANE_CLOSURES]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LONG_TERM_ROAD_CONSTRUCTION]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CONSTRUCTION_WORK]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.PAVING_OPERATIONS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.WORK_IN_THE_MEDIAN]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.NARROW_LANES]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CONSTRUCTION_TRAFFIC_MERGING]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.SINGLE_LINE_TRAFFIC_ALTERNATING_DIRECTIONS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.ROAD_MAINTENANCE_OPERATIONS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.ROAD_MARKING_OPERATIONS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.BRIDGE_MAINTENANCE_OPERATIONS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.BRIDGE_CONSTRUCTION]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.BRIDGE_DEMOLITION_WORK]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.WATER_MAIN_WORK]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.GAS_MAIN_WORK]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.WORK_ON_UNDERGROUND_CABLES]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.WORK_ON_UNDERGROUND_SERVICES]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TEMPORARY_LANE_MARKINGS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TEMPORARY_TRAFFIC_LIGHTS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.EMERGENCY_MAINTENANCE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.ROADSIDE_CLEANUP_CREW]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.BRIDGE_INSPECTION_WORK]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.NIGHT_TIME_CONSTRUCTION_WORK]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.WORK_ON_THE_SHOULDER]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.EMERGENCY_REPAIRS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.STREET_CLEANING]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.UTILITY_WORK]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.ROADWORK]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.AUTOMATED_ENFORCEMENT_AREA]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.OBSTRUCTION_ON_ROADWAY]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.DEBRIS_ON_ROADWAY]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.STORM_DAMAGE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.HERD_OF_ANIMALS_ON_ROADWAY]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.FALLEN_TREES]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.DOWNED_POWER_LINES]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.DOWNED_CABLES]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.ROAD_SURFACE_COLLAPSE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.PAVEMENT_BUCKLED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.POTHOLE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.FLOODING]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.BROKEN_WATER_MAIN]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.COLLAPSED_SEWER]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.GAS_LEAK]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.POLICE_DIRECTING_TRAFFIC]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.ROUGH_ROAD]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.VEHICLE_FIRE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.FIRE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.BUILDING_FIRE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LOCAL_EVENT]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.OVERSIZE_LOAD]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TRAFFIC_HAZARD]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.DELAYS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.SHORT_DELAYS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LONG_DELAYS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.VERY_LONG_DELAYS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.EMERGENCY_VEHICLES]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.WIDE_LOAD]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.OVERHEIGHT_LOAD]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.OVERWEIGHT_LOAD]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.SLOW_MOVING_MAINTENANCE_VEHICLE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CONVOY]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.SNOWPLOWS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.MOBILE_MAINTENANCE_OPERATIONS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LANE_CONTROL_SIGNS_NOT_WORKING]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LANE_CONTROL_SIGNS_WORKING_INCORRECTLY]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.VARIABLE_MESSAGE_SIGNS_NOT_WORKING]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.VARIABLE_MESSAGE_SIGNS_WORKING_INCORRECTLY]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TRAFFIC_LIGHTS_NOT_WORKING]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TRAFFIC_LIGHTS_WORKING_INCORRECTLY]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.RAMP_CONTROL_SIGNALS_NOT_WORKING]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.RAMP_CONTROL_SIGNALS_WORKING_INCORRECTLY]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TEMPORARY_TRAFFIC_LIGHTS_NOT_WORKING]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TEMPORARY_TRAFFIC_LIGHTS_WORKING_INCORRECTLY]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TRAFFIC_SIGNAL_MAINTENANCE_WORK]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.RESTRICTIONS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.RAMP_RESTRICTIONS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TRUCK_RESTRICTION]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.SPEED_RESTRICTION]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LOCAL_ACCESS_ONLY]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.NO_TRAILERS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.NO_THROUGH_TRAFFIC]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.WIDTH_LIMIT]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.HEIGHT_LIMIT]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LENGTH_LIMIT]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.AXLE_LOAD_LIMIT]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.GROSS_WEIGHT_LIMIT]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.NO_OVERLOADS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.PERMITTED_OVERSIZE_LOADS_PROHIBITED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.NO_COMMERCIAL_TRAILER_TRAFFIC]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.ROUNDABOUT]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.GRASS_FIRE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.SLOW_TRAFFIC]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LONG_QUEUES]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TRAFFIC_CONGESTION]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CLOSED_AHEAD]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CLOSED_FOR_REPAIRS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.BLOCKED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.REDUCED_TO_ONE_LANE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.REDUCED_TO_TWO_LANES]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.REDUCED_TO_THREE_LANES]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CONSIDER_ALTERNATE_ROUTE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CLEARED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.RIGHT_LANE_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LEFT_LANE_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CENTER_LANE_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.RIGHT_SHOULDER_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LEFT_SHOULDER_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.EXIT_RAMP_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.ENTRANCE_RAMP_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.THROUGH_LANES_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.SHOULDER_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.PILOT_CAR_IN_OPERATION]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.RIGHT_LANE_BLOCKED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TWO_RIGHT_LANES_BLOCKED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.THREE_RIGHT_LANES_BLOCKED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LEFT_LANE_BLOCKED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TWO_LEFT_LANES_BLOCKED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LEFT_LANE_OF_EXIT_RAMP_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.RIGHT_LANE_OF_EXIT_RAMP_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.RAMP_BLOCKED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CLOSED_TO_ALL_TRAFFIC_EXCEPT_EMERGENCY_VEHICLES]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.ALL_LANES_BLOCKED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.SIDEWALK_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LEFT_TURN_BAY_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.RIGHT_TURN_BAY_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LANE_CLOSED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.ROAD_CONSTRUCTION]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.MAJOR_ROAD_CONSTRUCTION]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.ROAD_RECONSTRUCTION]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.OPPOSING_TRAFFIC]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.NEW_ROAD_CONSTRUCTION_LAYOUT]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.NEW_ROAD_LAYOUT]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.BRUSH_CONTROL]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.PLANNED_ROADWORK]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.FESTIVAL]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.PARADE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.RAMP_PARTIALLY_BLOCKED]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TEMPORARY_FOUR_WAY_STOP_CONDITION]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.BICYCLE_RACE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.FAIR]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.WE_APPRECIATE_YOUR_PATIENCE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.EXTRA_POLICE_PATROLS_IN_OPERATION]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.REPAIRS_IN_PROGRESS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.LOOK_OUT_FOR_FLAGGER]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.FINES_ARE_DOUBLED_IN_THE_WORK_ZONE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.CHANGING_TRAFFIC_PATTERNS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TRUCKS_ENTERING_ROADWAY]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.USE_RIGHT_LANE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.USE_LEFT_LANE]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.THROUGH_TRAFFIC_KEEP_LEFT]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.THROUGH_TRAFFIC_KEEP_RIGHT]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.NORTHBOUND_TRAFFIC]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.EASTBOUND_TRAFFIC]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.SOUTHBOUND_TRAFFIC]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.WESTBOUND_TRAFFIC]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.FOLLOW_DETOUR_SIGNS]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.FOLLOW_LOCAL_DETOUR]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
    [EventTypes.TRUCKS_ARE_RECOMMENDED_TO_AVOID_THE_AREA]: {
      importTo511: true,
      color: null,
      restriction: null,
      defaultFormSections: {
        DMS: false,
        VEHICLES: false,
        RESPONDING_UNITS: false,
      },
      respondingUnitSuggestions: {},
    },
};
